<template>
  <v-skeleton-loader
    class="kp-navigation-dashboards-and-tables"
    :loading="loadingAllDashboards"
    type="list-item@10"
  >
    <v-list-group
      v-for="dashboardCategory in filteredDashboardList"
      :key="t(dashboardCategory.category)"
      :value="dashboardCategory.category"
      class="kp-navigation-dashboards-and-tables__category"
    >
      <template #activator="{ props }">
        <v-list-item
          v-tooltip:top="t(dashboardCategory.tooltip)"
          v-bind="props"
          :prepend-icon="dashboardCategory.icon"
        >
          <template #title>
            {{ t(dashboardCategory.category) }}
          </template>
        </v-list-item>
      </template>
      <KpNavigationDrawerItem
        v-for="dashboard in dashboardCategory.items"
        :key="`navigation-${dashboard.title}`"
        class="kp-navigation-dashboards-item kp-navigation-dashboards-and-tables__item rounded"
        :data-cy="dashboard.title"
        :title="t(dashboard.title)"
        :tooltip="t(dashboard.tooltip)"
        :to="dashboard.url"
      />
    </v-list-group>
  </v-skeleton-loader>
</template>
<script setup>
import { computed, ref } from 'vue';
import { useQuery } from '@vue/apollo-composable';
import { useI18n } from 'vue-i18n';

import gql from 'graphql-tag';
import { CORE_DASHBOARD_FIELDS } from '~/graphql/fragments';
import useNavigationDrawer from '~/composables/useNavigationDrawer';
import useDashboard from '~/composables/useDashboard';
import KpNavigationDrawerItem from './KpNavigationDrawerItem.vue';

const {
  getFilteredDashboardList,
} = useNavigationDrawer();

const {
  userDashboards,
} = useDashboard();

const { t } = useI18n();
const allDashboards = ref([]);
const { onResult: onResultAllDashboards, loading: loadingAllDashboards } = useQuery(
  gql`
    query AllDashboards {
      dashboards(first: 200, page:1) {
        data {
          ...CoreDashboardFields
        }
      }
    }
    ${CORE_DASHBOARD_FIELDS}
  `,
  {},
);
onResultAllDashboards((result) => {
  allDashboards.value = result.data?.dashboards?.data ?? [];
});

/**
 * Will only return the dashboard the user has access to
 */
const filteredDashboardList = computed(() => {
  let allowedDashboards = userDashboards.value ?? [];
  if (allowedDashboards.length === 0) {
    allowedDashboards = allDashboards.value;
  }
  return getFilteredDashboardList(allowedDashboards);
});
</script>
